// src/api/deletePost.js

export const deletePost = async ({ user_id, auth_code, post_id, reason }) => {
  try {
    const response = await fetch(
      'https://writemybio.us/bio/api/code/admin/moderate_post.php',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id, auth_code, post_id, reason })
      }
    );

    const data = await response.json();

    if (!response.ok || data.error) {
      throw new Error(data.error || 'Failed to delete post');
    }

    return data;
  } catch (err) {
    throw new Error(err.message || 'Failed to delete post');
  }
};